module.exports = __webpack_public_path__ + "sx8-00ed4d3a.png";